import { format } from 'date-fns';
import { VisitorResponse } from '../types';

interface VisitorItemProps {
  visitor: VisitorResponse;
  onClick: () => void;
  isSelected?: boolean;
}

export default function VisitorItem({
  visitor,
  onClick,
  isSelected = false,
}: VisitorItemProps) {
  const displayName =
    visitor.first_name && visitor.surname
      ? `${visitor.first_name} ${visitor.surname}`
      : visitor.visitor_id;

  const subtitle = visitor.email || 'visitor';

  return (
    <div
      onClick={onClick}
      className={`
        flex cursor-pointer items-center justify-between border-b border-gray-100 px-4 py-3 transition-colors hover:bg-gray-50
        ${isSelected ? 'bg-gray-50 border-l-4 border-l-[#c31330]' : 'border-l-4 border-l-transparent'}
      `}
    >
      <div className="flex min-w-0 flex-1 items-start gap-2 pr-2">
        {visitor.has_unread_messages && (
          <span
            className="h-2.5 w-2.5 shrink-0 rounded-full bg-blue-500 mt-1"
            title="Unread messages"
          />
        )}
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-sm font-medium text-gray-900">
            {displayName}
          </h3>
          <p className="mt-0.5 text-xs text-gray-500 truncate">{subtitle}</p>
          {visitor.member_number && (
            <p className="mt-0.5 text-xs text-gray-500 truncate">
              Member #{visitor.member_number}
            </p>
          )}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {visitor.is_flagged && (
          <span className="text-sm text-red-500" title="Flagged chat">
            ❗
          </span>
        )}
        <span className="text-xs text-gray-400">
          {format(new Date(visitor.last_activity), 'MMM d, HH:mm')}
        </span>
      </div>
    </div>
  );
}
